import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { downloadTable } from "../../../../helpers";
const RejectedPayments = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const rejectedPaymentsData = useSelector(
    (state) => state?.financeReducer?.rejectedPaymentsData
  );
  useEffect(() => {
    dispatch(actions.getRejectedPaymentsData());
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0 mt-3">
              <div className="container px-0">
                <div class="row mx-0">
                  <div class="shadowclass">
                    <div class="col-12">
                      <div class="counts">
                        <h4 class="event-alert">
                          {" "}
                          Rejected Payment{" "}
                          <a
                            href="#"
                            onClick={() => {
                              downloadTable(
                                "rejectedPaymentsTable",
                                "Rejected Payments",
                                "GoGMGo Payments"
                              );
                            }}
                            class="print-cammond"
                          ></a>
                        </h4>
                        <div class="row justify-content-between">
                          <div class="col-md-4">
                            <div class="search-box">
                              <form
                                action="/productions"
                                id="MenuItemIndexForm"
                                method="get"
                                accept-charset="utf-8"
                              >
                                <input
                                  name="keyword"
                                  placeholder="Search"
                                  type="text"
                                  id="MenuItemKeyword"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="shadowclass mt-0 px-0">
                          <div
                            className="table-responsive"
                            id="rejectedPaymentsTable"
                          >
                            <table className="checklist-table">
                              <thead>
                                <tr>
                                  <th> ID </th>
                                  <th className="min-wd-150">Payee</th>
                                  <th>Amount</th>
                                  <th>Tax</th>
                                  <th>Payment Account</th>
                                  <th>Transaction Date</th>
                                  <th>Created</th>
                                  <th> Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rejectedPaymentsData?.payments?.map(
                                  (el, idx) => (
                                    <tr>
                                      <td>{idx + 1}</td>
                                      <td>
                                        <b>{el?.finance_payee?.payee_name}</b>{" "}
                                        <br />
                                        {el?.finance_payee?.finance_group?.name}
                                      </td>
                                      <td>
                                        {" "}
                                        {rejectedPaymentsData?.currency +
                                          " " +
                                          el?.amount}
                                      </td>
                                      <td>
                                        {rejectedPaymentsData?.currency +
                                          " " +
                                          el?.tax}
                                      </td>
                                      <td>{el?.payment_account?.name}</td>
                                      <td>{el?.transaction_date}</td>
                                      <td>{el?.created.slice(0, 10)}</td>
                                      <td>
                                        <a
                                          onClick={() => {
                                            dispatch(
                                              actions?.getViewPaymentData({
                                                id: el?.id,
                                              })
                                            );
                                            history.push(
                                              "/finance/payments/view-payment",
                                              {
                                                id: el?.id,
                                              }
                                            );
                                          }}
                                          class="circle_icon"
                                        >
                                          <i class="iconSprites eye-icon"></i>
                                        </a>{" "}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default RejectedPayments;
